import {
  EmployeeOfProjectMemberEmployee,
  ProjectMemberEmployee,
} from 'hooks/useProjectMemberEmployee/interfaces';

export default function getUniqueEmployees(
  projectMemberEmployees: ProjectMemberEmployee[],
) {
  const employeesOfProject = projectMemberEmployees.map((projectMember) => ({
    ...projectMember.employee,
  }));

  const uniqueEmployees: EmployeeOfProjectMemberEmployee[] = [];
  const ids = new Set();

  employeesOfProject.forEach((projectEmployee) => {
    if (ids.has(projectEmployee['@id'])) {
      return;
    }

    ids.add(projectEmployee['@id']);
    uniqueEmployees.push(projectEmployee);
  });

  return uniqueEmployees;
}
